<template>
  <span>
    <span @click="handleOpen ">
      <slot></slot>
    </span>
    <el-dialog append-to-body :title="title" :visible="dialogVisible" :width="width" @close="dialogVisible = false">
      <div>
        <p>欢迎阅读简单客服务协议(下称“本协议”)。本协议是您（个人或单一实体）与河北畅麦科技有限公司（以下简称“畅麦科技”）之间有关简单客的法律协议。本“软件产品”包括计算机软件，并可能包括但不限于相关媒体、印刷材料、电子文档、畅麦科技提供给您的原“软件产品”的任何更新和补充资料。您一旦安装、复制、下载、访问或以其它方式使用简单客，即表示您同意接受本《协议》各项条款的约束，并且对本协议及产品说明书、声明等全部系列文件已明确知悉并接受。如您不同意本《协议》中的条款，请不要安装或使用简单客产品。</p>
        <h6>1、用户授权：</h6>
        <p>畅麦科技，将本“软件产品”的使用权依据本协议的约定授予您。本“软件产品”受著作权法及其它知识产权法和相关国际条约的保护。本“软件产品”只能在《协议》许可的范围、方式予以使用，而不能另行出售、复制、修改、转让等。本协议有效期间，您仅享有依据本协议约定的使用权，本软件产品的其他任何权益，均归畅麦科技所有。</p>
        <h6>2、试用期约定：</h6>
        <p>
          ①在正式购买简单客前，您可以通过手机号方式进行验证注册，验证注册后，您将享有简单客30天的免费试用期。
          <br />②在试用期结束前，如您在连续3个月中未尝试登录，我们可能会冻结您的数据。您可以联系我们的工作人员解冻您的数据。
          <br />③在试用期结束前，如需正式购买，请联系畅麦科技工作人员。
          <br />④试用期结束后，畅麦科技没有义务为您保留原账号中或与之相关的任何信息。
        </p>
        <h6>3、您保证不：</h6>
        <p>
          ①将软件或其使用权利，有偿或无偿向其他单位或个人销售、转租、转借、转让；
          <br />②向其他单位或个人提供软件或资料的复制品；
          <br />③对软件作改变、反编译、反汇编等反向工程处理；
          <br />④试图进行任何获得本“软件”原代码的访问或行为;
          <br />⑤除掉或掩盖有关软件著作权或商标的标志；
          <br />⑥其他超越或违反本协议规定行使软件权利的行为。
          <br />您违反上述保证之时，您的使用权即自行终止。
        </p>
        <h6>4、风险提示：</h6>
        <p>畅麦科技特别提示您：请注意本软件产品使用过程中的风险控制，使用本软件产品由您自己承担风险，此软件不包含任何使用保证，不能保证适用或不出故障。在适用法律允许的最大范围内，畅麦科技在任何情况下不就因使用或不能使用本软件产品所发生的特殊的、意外的、直接或间接的损失承担赔偿责任。对您因软件遗失、被盗、毁损、误用、或擅自修改造成的损失畅麦科技不承担任何责任。在意外的、不可预料的情况下，对于注册用户免费升级及免费获得新注册码的服务承诺将自动终止。</p>
        <h6>5、责任有限：</h6>
        <p>畅麦科技不就因使用或不能使用本“软件”所引起的或有关的任何间接的、意外的、直接的、特殊的、惩罚性的或其它任何损害（包括但不限于因人身伤害或财产损坏而造成的损害，因利润损失、数据损失、营业中断、计算机瘫痪或故障、商业信息的遗失而造成的损害，因未能履行包括诚信或相当注意在内的任何责任致使隐私泄露而造成的损害，因疏忽而造成的损害，或因任何金钱上的损失或任何其它损失而造成的损害）承担赔偿责任，即使畅麦科技事先被告知该损害发生的可能性。因软件属虚拟产品，付费成功后不接受退货退款。</p>
        <h6>6、注册义务</h6>
        <p>您在简单客产品网站或其他应用平台进行注册，注册时需要通过手机或第三方应用授权等方式进行验证，您保证，所提供的资料是真实、准确、和完整的，倘若您提供任何不真实、不准确、不完整或不能反映当前情况的资料，畅麦科技有权暂停或终止您的注册身份及资料，并拒绝您在目前或将来对“服务”(或其任何部份)以任何形式使用。畅麦科技对您所提交的资料的安全性不承担任何责任或义务。</p>
        <h6>7、账户、密码和保密</h6>
        <p>
          在注册过程中，您将选择账户名和密码。您须自行负责对您的账户名和密码保密，且须对您在账户名和密码下发生的所有活动承担责任。畅麦科技不对您所保管的账户、密码被其他任何第三人使用及其产生的后果承担任何责任、义务。 您同意：
          <br />①如发现任何人未经授权使用您的账户名或密码，或发生违反保密规定的任何其他情况，您会立即通知简单客；
          <br />②确保您在每个使用时段结束时，以正确步骤离开操作平台。简单客不能也不会对因您未能遵守本款规定而发生的任何损失或损毁负责。
        </p>
        <h6>8、关于通知</h6>
        <p>
          所有发给您的通知，都可通过短信、push推送、电子邮件、简单客进销存产品内适当位置公告的形式进行发送。简单客将通过以上方式之一将重要信息传递给您，包括但不限于：告知服务条款的修改，告知服务器停机、版本升级或其它重要事项。
          为了使您及时全面了解畅麦科技提供的各项服务，您同意，畅麦科技公司可以多次、长期向您发送商业类短信/邮件而无需再次经过您的授权同意。
        </p>
        <h6>9、终止或访问限制</h6>
        <p>
          ①您同意，在使用简单客时，应自行妥善保管您所提交的资料及在享受服务过程中所形成的相关资料、信息等。在简单客未向您收费的情况下，可随时停止提供“服务”，并删除和丢弃您在使用“服务”中提交的“您的资料”，并且无须通知。对由此所可能产生的责任与损失，畅麦科技无须承担任何责任。
          <br />②您若违反本协议的任一条款与条件，畅麦科技可随时终止服务。终止服务之时，您必须立即终止使用简单客。
          <br />若您对本协议内容有任何疑问，可通过邮件与我们联系：
          <span style="color: #409EFF;">3138086589@qq.com</span>
          <br />本协议最终解释权归河北畅麦科技有限公司所有。
        </p>
      </div>
    </el-dialog>
  </span>
</template> 
    
    <script>
export default {
  name: '',
  directives: {},
  props: {
    title: {
      type: String,
      default: '简单客产品服务协议条款'
    }
  },

  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    width() {
      if ((/(Android)/i.test(navigator.userAgent) || /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) && !this.$route.query.from) {
        return '90%'
      } else {
        return '1000px'
      }
    }
  },
  created() {},

  methods: {
    handleOpen() {
      this.dialogVisible = true
    }
  }
}
</script>
    
<style lang="scss" scoped>
p {
  margin-top: 5px;
  color: #999;
  margin-bottom: 20px;
  line-height: 20px;
}
h6 {
  margin: 0;
}
</style>
    